import EventModel from '../EventModel';

import {IEventData} from 'coreClasses/events/IEvents';
import ManagerRepository from 'coreClasses/ManagerRepository';

/**
 * Represents ClickImageCtaEventModel
 */
export default class ClickImageCtaEventModel extends EventModel {
	public event: string;
	public cta_id: string;
	public image_index: string;
	public screen_width: number;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);
		this.event = data.event;
		this.cta_id = data.cta_id;
		this.image_index = data.image_index;
		this.screen_width = data.screen_width;
	}

	/**
	 * Checks if event is persistent
	 * @returns {boolean} true if event is persistent
	 */
	public isPersistentEvent() {
		return false;
	}

	/**
	 * Is independent event and should not wait for other
	 * @returns {boolean} is independent event
	 */
	public isIndependentEvent() {
		return true;
	}
}